import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
  selector: 'app-about',
  standalone: true,
  templateUrl: './about.component.html',
  styleUrl: './about.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [],
})
export class AboutComponent {
}
